<cj-form-field>
  <cj-form-label *ngIf="label">{{ label }}</cj-form-label>
  <input
    cjInput
    [placeholder]="placeholder"
    [fullWidth]="fullWidth"
    [status]="isValid ? '' : 'danger'"
    [inputMask]="currencyInputMask"
    [ngModelOptions]="{ standalone: true }"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    (input)="changed.emit()"
    [disabled]="disabled"
  />
  <div cjSuffix class="d-flex options">
    <button
      class="rounded"
      [class.active]="!isPercentage"
      [class.disabled]="disabled"
      [disabled]="disabled"
      cjButton
      status=""
      (click)="typedChanged.emit('USD')"
    >
      <cj-icon icon="dollar-sign" pack="font-awesome-solid"> </cj-icon>
    </button>
    <button
      class="rounded"
      [class.active]="isPercentage"
      [class.disabled]="disabled"
      [disabled]="disabled"
      cjButton
      status=""
      (click)="typedChanged.emit('%')"
    >
      <cj-icon icon="percentage" pack="font-awesome-solid"> </cj-icon>
    </button>
  </div>
</cj-form-field>
<!-- For NgForm Input number validation -->
<input
  type="number"
  [min]="0"
  [name]="name"
  [required]="required || null"
  [ngModel]="amount"
  [ngModelOptions]="{ standalone: true }"
  hidden
/>
